import React from "react";
import { formatCurrency } from "../../utils/currency";
import { Box } from "@mui/material";

function OrderActionTotal({ itemTotal }) {
  return (
    <Box className="menu-item-total-wrap">
      <Box
        style={{
          display: "flex",
          gap: 10,
        }}
      ></Box>
      <Box
        style={{
          display: "flex",
          gap: 5,
          justifyContent: "center",
          alignItems: "center",
          padding: "10px",
        }}
      >
        <Box
          style={{
            fontSize: 13,
          }}
        >
          Total:
        </Box>
        <Box
          style={{
            fontSize: 15,
            fontWeight: 700,
          }}
        >
          {formatCurrency(itemTotal, true)}
        </Box>
      </Box>
    </Box>
  );
}

export default OrderActionTotal;
